export const pagamentoStatus = {
    CRIADO: 0,
    EM_ANALISE: 1,
    EM_PROCESSAMENTO_PELO_SETOR_FINANCEIRO: 2,
    REPROVADO: 3,
    REPROVADO_PELO_SETOR_FINANCEIRO: 4,
    CONCLUIDO: 5,
    CANCELADO: 6,
    EXCLUIDO: 7,
    AGUARDANDO_SETOR_FINANCEIRO: 9
}
